/**
 * Uppercases the first non-whitespace character; leaves the rest of the string unchanged.
 */
export function capitalizeLeadingCharacter(text: string): string {
  const match = text.match(/^(\s*)(\S)(.*)$/s);
  if (!match) return text;
  return `${match[1]}${match[2].toUpperCase()}${match[3]}`;
}

/** Company description / sub-description for read-only UI (capitalizes first word). */
export function formatCompanyProfileTextForDisplay(value: unknown, fallback = "N/A"): string {
  if (value == null || value === "") return fallback;
  return capitalizeLeadingCharacter(String(value));
}
